import React from 'react';

function Works() {
  return (
    <section className="section-padding pt-0">
      <div className="container-xl">
        <div className="row lg-marg">
          <div className="col-lg-6">
            <div className="imgs md-mb80">
              <div className="mb-30">
                <img src="/dark/assets/imgs/works/projects/4/1.jpg" alt="" />
              </div>
              <div className="mb-30">
                <img src="/dark/assets/imgs/works/projects/4/2.jpg" alt="" />
              </div>
              <div>
                <img src="/dark/assets/imgs/works/projects/4/3.jpg" alt="" />
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="sticky-item">
              <div className="text">
                <h2 className="mb-30">The Challenge</h2>
                <h5 className="mb-30 line-height-40">
                  The goal is there are many variations of passages of but the
                  majority have suffered alteration in some form, by injected
                  humour, or randomised words which don&apos;t look even
                  slightly believable.
                </h5>
                <p className="fz-18">
                  There are many variations of passages of Lorem Ipsum
                  available, but the majority have suffered alteration in some
                  form, by injected humour, or randomised words which don&apos;t
                  look even slightly believable.
                </p>
              </div>
              <div className="info pt-80 mt-80 bord-thin-top">
                <div className="row">
                  <div className="col-md-6">
                    <div className="item mb-30">
                      <span className="opacity-8 mb-5">Category :</span>
                      <h6>Development</h6>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="item mb-30">
                      <span className="opacity-8 mb-5">Client :</span>
                      <h6>Envato</h6>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="item mb-30">
                      <span className="opacity-8 mb-5">Start Date :</span>
                      <h6>7 August 2021</h6>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="item">
                      <span className="opacity-8 mb-5">Designer :</span>
                      <h6>UiCamp</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Works;
